import { GraphType, SwarmType } from './gen/graphql';

export const SwarmTypeTranslations = Object.freeze({
    [SwarmType.Vibration]: gettext('SWARM_VIBRATION'),
    [SwarmType.Air]: gettext('SWARM_AIR'),
    [SwarmType.Sound]: gettext('SWARM_SOUND'),
});

export enum ContentTab {
    GRAPH = 'graph',
    DAILY_VALUES = 'daily-values',
    LDEN = 'lden',
}

export const SwarmIconClasses = Object.freeze({
    [SwarmType.Air]: 'swarm-air-icon',
    [SwarmType.Vibration]: 'swarm-vibration-icon',
    [SwarmType.Sound]: 'swarm-sound-icon',
});

// Re-exporting for backward compatibility.
export { SwarmType, GraphType };
